import React, { useEffect, useState } from "react";
import "./template-filters.scss";
import { Checkbox } from "@Common/ui-components/heavy/common/design2/checkbox/checkbox";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import {parseUrlQuery} from "@Common/utils/parse-url-query";

export const TemplateFilters = ({queryParam, urlParams, setUrlParams, categoryFilters, setCurrentPage}) => {
    // const [urlParams, setUrlParams] = useState(parseUrlQuery(window.location.search));
    const updatedFilters = updateFilters(urlParams, categoryFilters);
    useEffect(() => {
        const handlePopState = () => {
            setUrlParams(parseUrlQuery(window.location.search));
        };

        window.addEventListener("popstate", handlePopState);
        return () => window.removeEventListener("popstate", handlePopState);
    }, []);

    const [expandedSections, setExpandedSections] = useState({
        products: true,
        categories: true
    });

    const handleCheckboxClick = (type, itemName) => {
        const newParams = { ...urlParams, q: queryParam };
        let selectedItems = newParams[type] ? newParams[type].split("~") : [];
    
        if (selectedItems.includes(itemName)) {
            selectedItems = selectedItems.filter(item => item !== itemName);
        } else {
            selectedItems.push(itemName);
        }
    
        if (selectedItems.length) {
            newParams[type] = selectedItems.join("~");
        } else {
            delete newParams[type];
        }

        updateUrlParams(newParams);
        setCurrentPage(1)
    };

    const handleClearAll = () => {
        const newParams = { q: urlParams.q };
        
        updateUrlParams(newParams);
        setCurrentPage(1);
    };

    const updateUrlParams = (params) => {
        const queryString = new URLSearchParams(params).toString();
        const newUrl = `${window.location.pathname}?${queryString}`;
        
        window.history.pushState({}, "", newUrl);
        setUrlParams(params);
    };

    const toggleExpand = (type) => {
        setExpandedSections(prevState => ({
            ...prevState,
            [type]: !prevState[type]
        }));
    };

    return (
        <div className="tmplf-trst00">
            <div className="header">
                <div className="bold-header">Filters</div>
                <div className="base-25" onClick={() => handleClearAll()}>Clear All</div>
            </div>

            {["products", "categories"].map((type) => (
                <div key={type} className={`${type}-filter`}>
                    <div className="filter-header" onClick={() => toggleExpand(type)}>
                        <div className="bold-text">{type.charAt(0).toUpperCase() + type.slice(1)}</div>
                        <div className="expand grey-text">
                            <FontAwesomeIcon icon={expandedSections[type] ? faChevronUp : faChevronDown} />
                        </div>
                    </div>
                    {expandedSections[type] && (
                        updatedFilters[type] && updatedFilters[type].map((v, index) => (
                            <LineItem key={v.name} item={v} onClick={() => handleCheckboxClick(type, v.name)} />
                        ))
                    )}
                    <hr />
                </div>
            ))}
        </div>
    );
};

const LineItem = ({ item, onClick }) => {
    return (
        <div className="line">
            <div className="checkbox">
                <Checkbox checked={item.checked} onClick={onClick} />
            </div>
            <div className="spaced-line">
                <div className="line-name" onClick={onClick}>{item.name}</div>
                <div className="base-25 count">{item.count}</div>
            </div>
        </div>
    );
};

const updateFilters = (urlParams, filters) => {
    return Object.keys(filters).reduce((acc, type) => {
        const selectedItems = urlParams?.[type] ? urlParams[type].split("~") : [];

        acc[type] = filters[type].map(item => ({
            ...item,
            checked: selectedItems.includes(item.name)
        }));

        return acc;
    }, {});
};